import React from 'react';
import OpenInVsc from '../../../svg/open-in-vsc.svg';
import withIconSvg from '../helpers/withIconSvg';

const VSIcon: React.FC = (props) => {
	return <OpenInVsc {...props} />;
};

export default withIconSvg(VSIcon, true, { tags: ['vs', 'vs code', 'site shell', 'shell', 'terminal', 'open'] });
